import { NativeAudio } from "@ionic-native/native-audio";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { Storage } from "@ionic/storage";
import { MerchantRentalYourspacePage } from "./../merchant-rental-yourspace/merchant-rental-yourspace";
import { MerchantOverviewPlazaPage } from "./../merchant-overview-plaza/merchant-overview-plaza";
import { ViewHeaderPage } from "./../view-header/view-header";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-merchant-shop-pay-rental-confirm",
  templateUrl: "merchant-shop-pay-rental-confirm.html",
})
export class MerchantShopPayRentalConfirmPage {
  result = {
    code: "",
    plaza_name: "",
    space_no: "",
    plaza_id: "",
    shop_id: "",
    shop_name: "",
    decoration: "",
    rental_fee: "",
    cost: "",
    max_stock: "",
    total_cost: "",
    discount: "",
    // isRentPaid: false,
  };
  success = false;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController,
    private nativeAudio: NativeAudio
  ) {
    this.nativeAudio.preloadSimple("uniqueId2", "assets/sounds/cash.aac");
  }

  // ##จ่ายค่าเช่า 3
  async ionViewDidLoad() {
    console.log("จ่ายค่าเช่า 3");
    this.theme = await this.storage.get("theme");

    // const loader = this.loadingCtrl.create({
    //   content: "Loading...",
    // });

    this.result = this.navParams.data.result;
    this.result.total_cost = this.services.currencyFormat(
      this.result.total_cost
    );

    console.log("result=", this.result);

    this.success = false;

    // var link = this.services.URLMerchantSpace + "/" + this.result.space_no;
    // var headers = new Headers();
    // headers.append("Content-Type", "application/x-www-form-urlencoded");
    // headers.append("Accept", "application/json");
    // headers.append("Authorization", "Bearer " + token);
    // const requestOptions = new RequestOptions({ headers: headers });

    // this.http
    //   .get(link, requestOptions)
    //   .map((res) => res.json())
    //   .subscribe(
    //     (data) => {
    //       // console.log('data=', data);

    //       this.result.shop_name = data.shop.shop_name;
    //       this.result.decoration = data.shop.decoration;
    //       this.result.rental_fee = data.shop.rental_fee;
    //       this.result.cost = data.shop.cost;
    //       this.result.max_stock = data.shop.max_stock;
    //       this.result.isRentPaid = data.isRentPaid;

    //       let total =
    //         parseFloat(data.shop.rental_fee) -
    //         parseFloat(data.shop.rental_fee) *
    //           (parseFloat(this.result.discount) / 100);
    //       this.result.total_cost = this.services.currencyFormat(total);
    //       loader.dismiss();
    //     },
    //     (error) => {
    //       var response = JSON.parse(error._body);
    //       loader.dismiss();
    //       this.translateService.get(response.message).subscribe((value) => {
    //         this.services.presentToast(value);
    //       });
    //     }
    //   );
    // });
  }

  confirm() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLMerchantRentSpaceConfirm;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });
      this.http
        .post(
          link,
          {
            code: this.result.code,
          },
          requestOptions
        )
        .map((res) => res.json())
        .subscribe(
          () => {
            this.success = true;
            this.nativeAudio.play("uniqueId2");
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
            loader.dismiss();
          }
        );
    });

    // this.storage.get("token").then((token) => {
    //   let body =
    //     "space_no=" +
    //     this.result.space_no +
    //     "&discount=" +
    //     this.result.discount;
    //   // + "&discount=" + this.result.discount;
    //   // console.log("body=", body);
    //   var link = this.services.URLMerchantSpace + "/" + this.result.space_no;
    //   var headers = new Headers();
    //   headers.append("Content-Type", "application/x-www-form-urlencoded");
    //   headers.append("Accept", "application/json");
    //   headers.append("Authorization", "Bearer " + token);
    //   const requestOptions = new RequestOptions({ headers: headers });

    //   this.http
    //     .post(link, body, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         this.success = true;
    //         this.nativeAudio.play("uniqueId2");
    //         loader.dismiss();
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);
    //         loader.dismiss();
    //         this.translateService.get(response.message).subscribe((value) => {
    //           this.services.presentToast(value);
    //         });
    //       }
    //     );
    // });
  }

  shop() {
    this.navCtrl.push(MerchantRentalYourspacePage);
  }

  map() {
    this.navCtrl.push(MerchantOverviewPlazaPage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-shop-pay-rental-confirm/merchant-shop-pay-rental-confirm.ts